import { FormlyFieldConfig } from "@ngx-formly/core";
import { OccupazioneUrgenzaStep } from "./steps/occupazione.step";
import { PrivacyDelegaStep } from "app/forms/shared/privacy-delega.step";
import { GiuridicaStep } from "app/forms/shared/giuridica.step";
import { IntestatarioStep } from "app/forms/shared/intestatario.step";

export const Urgenza: FormlyFieldConfig[] =  [
      {
        props: {
          slabel: "PRIVACY",
          label: "INFORMATIVA SULLA PRIVACY"
        },
        wrappers: ['panel-step'],
        fieldGroup: PrivacyDelegaStep
    },
      {
        props: {
          slabel: "INTESTATARIO",
          label: "DATI ANAGRAFICI INTESTATARIO"
      },
        wrappers: ['panel-step'],
        fieldGroup: [...IntestatarioStep, ...GiuridicaStep]
      },
      {
        props: {
          slabel: 'OCCUPAZIONE',
          label: 'ELEMENTI DI OCCUPAZIONE SUOLO PER URGENZE'
        },
        wrappers: ['panel-step'],
        fieldGroup: OccupazioneUrgenzaStep
      },
    ]
